export const convertObjToQueryParams = (obj: any) => {
  return "?" + new URLSearchParams(obj).toString();
};

export const getFormData = (data: any): FormData => {
  const formData = new FormData();
  const keys = Object.keys(data);
  keys.forEach((key) => {
    formData.append(key, data[key] ?? "");
  });
  return formData;
};

export const getAndAppendFormData = (data: any, formData: FormData) => {
  const keys = Object.keys(data);
  keys.forEach((key) => {
    formData.set(key, data[key] ?? "");
  });
};

// Format the price above to USD using the locale, style, and currency.
let USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const formatCurrency = (price: any) => {
  return USDollar.format(Number(price)).replace("$", "$");
};

export function convertMinutesToHoursAndMinutes(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0) {
    return `${hours} hr${hours !== 1 ? "s" : ""} ${minutes} Min${minutes !== 1 ? "s" : ""
      }.`;
  } else {
    return `${minutes} Min${minutes !== 1 ? "s" : ""}`;
  }
}

export function returnFirstNthElements(arr: any[], maxDisplay: number): any[] {
  return arr.slice(0, maxDisplay);
}
